import React, { useEffect, useState } from "react";
import { Checkbox } from "antd";

const TypeOfCallRenderer = (props) => {
  const { data, api, onChange } = props;
  const types = data.type_of_call || [];

  const isChecked = !!data.isChecked;
  const justChecked = !!data._justChecked;

  const order = ["Review", "Prospect", "FollowUp"];
  const displayNames = {
    Review: "Review",
    Prospect: "Lead",
    FollowUp: "Opportunity",
  };

  const defaultChecked = data.type_of_call_checked || {};
  const [checkedItems, setCheckedItems] = useState(defaultChecked);

  useEffect(() => {
    if (!isChecked) {
      setCheckedItems({});
      return;
    }

    if (justChecked && types.length > 0) {
      const allChecked = {};
      types.forEach((t) => (allChecked[t] = true));
      setCheckedItems(allChecked);


      const newData = { ...data, _justChecked: false };
      api.applyTransaction({ update: [newData] });
      return;
    }

    setCheckedItems(defaultChecked);

    // if (types.includes("Review")) {
    //   setCheckedItems({ Review: true });
    // } else if (types.includes("FollowUp") && types.includes("Prospect")) {
    //   setCheckedItems(defaultChecked);
    // } else {
    //   setCheckedItems({});
    // }
  }, [data, isChecked, justChecked, types, api]);



  const handleChange = (type, checked) => {
    setCheckedItems((prev) => {
      const updated = { ...prev, [type]: checked };
      console.log("Current selected items:", updated);

      const allUnchecked = Object.values(updated).every((v) => !v);
      data.type_selected = updated;
      data.isChecked = !allUnchecked;

      api.applyTransaction({ update: [data] });
      if (onChange) onChange(data);
      return updated;
    });
  };



  if (!Array.isArray(types) || types.length === 0) return <span>-</span>;
  if (!Array.isArray(types) || types.length == 1) return <span>{displayNames[types[0]]}</span>;

  return (
    <div style={{ display: "flex", gap: 12, height: "100%", alignItems: "center" }}>
      {order.map((type) => {
        if (!types.includes(type)) return null;
        return (
          <Checkbox
            key={type}
            disabled={!isChecked}
            checked={!!checkedItems[type]}
            onChange={(e) => handleChange(type, e.target.checked)}
            style={{ display: "flex", alignItems: "center", lineHeight: "1.2", margin: 0 }}
          >
            {displayNames[type]}
          </Checkbox>
        );
      })}
    </div>
  );
};

export default TypeOfCallRenderer;



// WEBPACK FOOTER //
// ./src/Custom-Tooltip/TypeOfCallRenderer.js